<template>
    <div class="container">
        <el-form :model="$store.state.registration"
                 :rules="rules"
                 class="demo-ruleForm"
                 label-width="100px"
                 ref="ruleForm"
                 v-loading="loading">
            <el-card style="padding-bottom: 10px;">
                <div class="clearfix" slot="header" style="border-bottom: aliceblue;">
                    <span v-if="bingli==1" >复发</span>
                    <span v-else-if="bingli==0" @dblclick="handelTabs" style="cursor: pointer">初发</span>
                    <span v-else>未</span>
                    <span v-if="groups=='6' || groups=='7'">
                        ( {{$store.state.registration.form1.xingming}} | {{$store.state.registration.form1.dianhua}} )
                    </span>
                    <span v-if="groups=='5'">
                        ({{$store.state.registration.form1.dianhua}})
                    </span>
                    <div class="calculator" v-if="activeName=='six'" @click="calculatorModel=true">
                        <img src="../../assets/images/calculator.png"  />
                    </div>
                </div>
                <el-tabs :before-leave="beforeLeave" @tab-click="handleClick"
                         size="medium" v-model="activeName" ref="tabs">
                    <el-tab-pane label="基本信息" v-if="showjiebnxinxi"
                                 name="first">
                        <span slot="label">基本信息<i class="el-icon-arrow-right"></i></span>
                        <Jibenxinxi @childCopy="getData" @childEvent="bingliChange"/>
                    </el-tab-pane>
                    <el-tab-pane :disabled="linchuangxinxiEnabled" v-if="showlinchuangxinxi"
                                 label="临床信息"
                                 name="second">
                        <span slot="label">临床信息<i class="el-icon-arrow-right"></i></span>
                        <Linchuangxinxi :bingli="bingli" :addedit="addedit" :updateFlag="updateFlag"
                                        ref="linchuangxinxi"/>
                    </el-tab-pane>
                    <el-tab-pane :disabled="xibaoyichuanEnabled"
                                 label="细胞遗传" v-if="showlinchuangxinxi"
                                 name="third">
                        <span slot="label">细胞遗传<i class="el-icon-arrow-right"></i></span>
                        <Xibaoyichuan :addedit="addedit"/>
                    </el-tab-pane>
                    <el-tab-pane :disabled="fenzibiaozhiEnabled"
                                 label="分子标志" v-if="showlinchuangxinxi"
                                 name="four">
                        <span slot="label">分子标志<i class="el-icon-arrow-right"></i></span>
                        <Fenzibiaozhi :addedit="addedit" ref="fenzi"/>
                    </el-tab-pane>
                    <el-tab-pane :disabled="mianyibiaoxingEnabled"
                                 label="免疫表型" v-if="showlinchuangxinxi"
                                 name="five">
                        <span slot="label">免疫表型<i class="el-icon-arrow-right"></i></span>
                        <Mianyibiaoxing :bingli="bingli" :addedit="addedit"/>
                    </el-tab-pane>
                    <el-tab-pane :disabled="zhiliaoxinxiEnabled" v-if="showzhiliaoxinxi"
                                 label="治疗信息"
                                 name="six">
                        <span slot="label">治疗信息<i class="el-icon-arrow-right"></i></span>
                        <Zhiliaoxinxi :bingli="bingli" ref="zhiliaoxinxi"/>
                    </el-tab-pane>
                    <el-tab-pane :disabled="zhuanguifeiyongEnabled" v-if="showzhuanguifeiyong"
                                 label="转归费用"
                                 name="seven">
                        <Zhuanguifeiyong/>
                    </el-tab-pane>
                </el-tabs>
                <div style="margin-top: 30px; text-align:right" v-if="showBnt">
                    <ParticleEffectButton
                            :animating.sync="animating"
                            :button-options="buttonOptions"
                            :button-styles="buttonStyle"
                            :disabled="ondisabled"
                            :hidden.sync="hidden"
                            @onSubmit="onSubmit"
                            ref="editButtonRef"
                            status="4"
                            text="暂存待修改"
                    />
                    <ParticleEffectButton
                            :animating.sync="animating"
                            :button-options="buttonOptions"
                            :button-styles="buttonStyles"
                            :disabled="ondisabled"
                            :hidden.sync="hidden"
                            @onSubmit="onSubmit"
                            ref="demoButtonRef"
                            status="0"
                            text="提交审核"
                            v-if="activeName=='seven'"
                    />
                </div>
                <div style="margin-top: 30px; text-align:right" v-else>
                    <ParticleEffectButton
                            v-if="groups=='5'"
                            :animating.sync="animating"
                            :button-options="buttonOptions"
                            :button-styles="buttonStyle"
                            :disabled="ondisabled"
                            :hidden.sync="hidden"
                            @onSubmit="onSubmit"
                            ref="editButtonRef"
                            status="5"
                            text="驳 回"
                    />
                    <ParticleEffectButton
                            :animating.sync="animating"
                            :button-options="buttonOptions"
                            :button-styles="buttonStyles"
                            :disabled="ondisabled"
                            :hidden.sync="hidden"
                            @onSubmit="onSubmit"
                            ref="demoButtonRef"
                            status="7"
                            text="提 交"
                    />
                </div>
            </el-card>
            <div class="cachetime">
                浏览器数据自动保存：{{ cachetime }}
            </div>
            <cal v-if="calculatorModel && activeName=='six'" @close="calculatorModel = false"></cal>
            <el-dialog
                    title="驳回"
                    :visible.sync="model1"
                    width="40%"
            >
                <el-form :rules="rules" ref="formstatus" :model="formstatus">
                    <el-form-item label="驳回原因" label-width="120px" prop="opinion">
                        <el-input v-model="formstatus.opinion" style="width:80%" type="textarea"
                                  :autosize="{ minRows: 5, maxRows: 5}"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="model1 = false" size="min">取 消</el-button>
                    <ParticleEffectButton
                            :animating.sync="animating"
                            :button-options="buttonOptions"
                            :button-styles="buttonStyle"
                            :disabled="ondisabled"
                            :hidden.sync="hidden"
                            @onSubmit="onSubmit"
                            ref="editButtonRef"
                            status="9"
                            text="确 定"
                    />
                </span>
            </el-dialog>
        </el-form>
    </div>
</template>

<script>
    import ParticleEffectButton from '../../components/particle-effect-button'
    import Jibenxinxi from './forms/jibenxinxi'
    import Linchuangxinxi from './forms/linchuangxinxi'
    import Xibaoyichuan from './forms/xibaoyichuan'
    import Fenzibiaozhi from './forms/fenzibiaozhi'
    import Mianyibiaoxing from './forms/mianyibiaoxing'
    import Zhiliaoxinxi from './forms/zhiliaoxinxi'
    import Zhuanguifeiyong from './forms/zhuanguifeiyong'
    import Cal from './forms/widgets/cal'
    import * as table from '../../config/cyit'
    import '../../config/directives'

    var clickTimer = null

    export default {
        components: {
            Jibenxinxi,
            Linchuangxinxi,
            Xibaoyichuan,
            Fenzibiaozhi,
            Mianyibiaoxing,
            Zhiliaoxinxi,
            Zhuanguifeiyong,
            ParticleEffectButton,
            Cal
        },
        data() {
            var validateXingming = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入名称'));
                }
                callback();
            };
            // eslint-disable-next-line
            var validateNianling = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入年龄'));
                }
                callback();
            };
            var validateShenfenzheng = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入身份证号'));
                } else {
                    // if (15 <= value.length && value.length <= 18) {
                    if (value.length == 18) {
                        callback();
                    } else {
                        callback(new Error('身份证必须18位'));
                    }
                }
            };
            return {
                calculatorModel: false,
                tab: ["first","second","third","four","five","six","seven"],
                status: '',
                is_admin: false,
                ondisabled: false,
                dialogVisible: true,
                model1: false,
                loading: true,
                formstatus: {opinion: ''},
                updateFlag: false,
                groups: localStorage.getItem('groups'),
                bingli: this.$store.state.registration.form1.bingli,
                activeName: 'first',
                dialogImageUrl: '',
                addedit: 0,
                rules: {
                    opinion: [
                        {required: true, message: '必填', trigger: 'blur'},
                    ],
                    form1: {
                        xingming: [
                            {validator: validateXingming, trigger: 'blur'},
                        ],
                        // shenfenzheng: [
                        //     {validator: validateShenfenzheng, trigger: 'blur'},
                        // ],
                        huji: [
                            {type: 'array', required: true, message: '请选择', trigger: 'blur'},
                        ],
                        // nianling: [
                        //     {required: true, message: '请检查身份证号是否正确', trigger: 'blur'},
                        // ],
                    },
                    form2: {
                        jiuzhenriqi: [
                            {required: true, message: '必填', trigger: 'blur'},
                        ],
                    },
                },
                intervalBoxP: null,
                hidden: false,
                animating: false,
                buttonStyles: {
                    background: '#67c23a',
                    color: '#fff',
                    borderRadius: '4px',
                    border: '1px solid #67c23a',
                },
                buttonStyle: {
                    background: '#e6a23c',
                    color: '#fff',
                    borderRadius: '4px',
                    border: '1px solid #e6a23c',
                },
                buttonOptions: {
                    particleColor: '#121019',
                    duration: 2000,
                },
                defaulttime: false,
                cachetime: '',
                chlid: false
            }
        },
        computed: {
            showjiebnxinxi() {
                if (this.updateFlag) {
                    if (this.groups == '5' || this.groups == '7' || this.groups == '6') {
                        return false
                    }
                }
                return true
            },
            showlinchuangxinxi() {
                if (this.updateFlag) {
                    if (this.groups == '5' || this.groups == '7') {
                        return true
                    }
                    if (this.groups == '6') {
                        return false
                    }
                }
                return true
            },
            showzhiliaoxinxi() {
                if (this.updateFlag) {
                    if (this.groups == '6' || this.groups == '7') {
                        return true
                    }
                    if (this.groups == '5') {
                        return false
                    }
                }
                return true
            },
            showzhuanguifeiyong() {
                if (this.updateFlag) {
                    if (this.groups == '6' || this.groups == '7') {
                        return true
                    }
                    if (this.groups == '5') {
                        return false
                    }
                }
                return true
            },
            showBnt() {
                if (this.updateFlag) {
                    if (this.groups == '6' || this.groups == '7' || this.groups == '5') {
                        return false
                    }
                }
                return true
            },
            linchuangxinxiEnabled() {
                var data = this.$store.state.registration.form1
                var form = ['xingming', 'shenfenzheng', 'huji', 'xingbie', 'nianling', 'minzu']
                return this.handleEnabled(data, form)
            },
            xibaoyichuanEnabled() {
                return this.handleEnabled(this.$store.state.registration.form2, table.xibaoyichuanenabled)
            },
            fenzibiaozhiEnabled() {
                var data = this.$store.state.registration.form3
                if (data.weizuojiancha || data.aml.length != 0 || data.all.length != 0 || data.all_qita || data.aml_qita) {
                    return false
                }
                return true
            },
            mianyibiaoxingEnabled() {
                var form = this.$store.state.registration.form4
                if (form.weizuojiancha || form.negative) {
                    return false
                }
                for (var i in table.fenzi) {
                    if (form[table.fenzi[i]]) {
                        return false
                    }
                }
                return true
            },
            zhiliaoxinxiEnabled() {
                var form = this.$store.state.registration.form5
                if (form.weizuojiancha) {
                    return false
                }
                for (var key in form) {
                    if (key == 'weizuojiancha' || key == 'baogaotupian') {
                        console.log(key)
                    } else {
                        if (form[key]) {
                            return false
                        }
                    }
                }
                return true
            },
            zhuanguifeiyongEnabled() {
                var flag = 0
                var data = this.$store.state.registration.form6
                data.timeline.forEach(function (item) {
                    if(item.label == "治疗" || item.label == "放弃" || item.label == "失访" || item.label == "初治" ){
                        flag = 1
                    }
                })
                if(flag == 1){
                    return false
                }
                if(data.fangan_shijian){
                    for (let key in data.zhiliaofangan) {
                        if(data.zhiliaofangan[key]){
                            return flag
                        }
                    }
                }
                if(data.fangqi_shijian){
                    return false
                }
                if(data.shifang_shijian){
                    return false
                }
                return  true
            }
        },
        methods: {
            handelTabs(){
                var that = this
                for (let i = 0; i < that.tab.length; i++) {
                    if(that.activeName == that.tab[i]){
                        if((i+1)!=7) {
                            that.activeName = that.tab[i + 1]
                            that.handleClick()
                            return
                        }
                    }
                }
            },
            beforeLeave(activeName) {
                var that = this
                if (activeName == "seven") {
                    var p = new Promise((resolve, reject) => {
                        that.$refs.zhiliaoxinxi.$emit('childMethod', (res) => {
                            if (res == 0) {
                                this.$confirm('请选择治疗方案时间', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    // 你可以在这儿做些操作
                                    reject()
                                }).catch(err => {
                                    // 你可以在这儿做些操作
                                    reject(err)
                                })
                            } else {
                                resolve()
                            }
                        })
                    })
                    return p
                }
            },
            handleEnabled(form, data) {
                for (var i in data) {
                    if (!form[data[i]]) {
                        return true
                    }
                    if (form[data[i]] && form[data[i]].length == 0) {
                        return true
                    }
                }
                return false
            },
            bingliChange(val) {
                this.bingli = val
            },
            getNowFormatDate() {
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                var h = date.getHours();
                var m = date.getMinutes();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate + " " + h + ":" + m;
                return currentdate;
            },
            onStore() {
                var that = this
                if (clickTimer) {
                    window.clearTimeout(clickTimer);
                    clickTimer = null;
                }
                that.cachetime = that.getNowFormatDate()
                clickTimer = window.setTimeout(function () {
                    if (that.groups != "6") {
                        that.$refs.fenzi.init()
                    }
                    localStorage.setItem('cachetime', that.cachetime)
                    localStorage.setItem('tmpl', JSON.stringify(that.$store.state.registration))
                }, 300);
            },
            onSubmit(status, cab) {
                var that = this
                if (status == '9') {
                    var fstatu = 0
                    that.$refs['formstatus'].validate((valid) => {
                        if (valid) {
                            that.$store.state.registration.form1['opinion'] = that.formstatus.opinion
                        } else {
                            fstatu = 1
                        }
                    })
                    if (fstatu == 1) {
                        return;
                    }
                }
                if (that.groups == "5" && status == '5') {
                    that.model1 = true
                    return;
                }
                if (status == "9") {
                    status = "5"
                }
                if (this.ondisabled) {
                    return
                }
                if (this.groups != "6") {
                    this.$refs.fenzi.init()
                }
                this.$refs['ruleForm'].validate((valid) => {
                    if (status == "4") {
                        valid = true
                    }
                    if (valid) {
                        this.ondisabled = true
                        this.$store.state.registration.form1.status = status
                        this.$http.post('/case/add/', this.$store.state.registration)
                            .then(resp => {
                                if (resp.data.code == 1) {
                                    that.model1 = false
                                    localStorage.removeItem('tmpl')
                                    this.$store.state.registration.form1.pk = resp.data.pk
                                    if (cab) {
                                        cab(0)
                                    }
                                    if (this.chlid) {
                                        this.$emit('childEvent')
                                    }
                                } else if (resp.data.code == -1) {
                                    this.ondisabled = false
                                    this.$message({
                                        message: resp.data.errors,
                                        type: 'error'
                                    })
                                    if (cab) {
                                        cab(1)
                                    }
                                }
                                // eslint-disable-next-line no-unused-vars
                            }).catch(function (error) {
                            that.ondisabled = false
                            that.$message({
                                message: '请检查一下你的网络是否正常或者修改权限',
                                type: 'error'
                            })
                        });
                    } else {
                        this.ondisabled = false
                        var formd = that.$store.state.registration
                        if(!formd.form2.jiuzhenriqi){
                            this.$message({
                                message: '就诊年龄未填',
                                type: 'error'
                            })
                        }else if(formd.form1.shenfenzheng && formd.form1.shenfenzheng.length != 18) {
                            this.$message({
                                message: '请检查身份证是否是18位',
                                type: 'error'
                            })
                        }
                        if (cab) {
                            cab(1)
                        }
                    }
                })
            },
            handleClick() {
                var that = this
                try {
                    that.$refs.zhiliaoxinxi.getZhiliaaoData()
                } catch(err){
                    console.error(err)
                }
                if (this.activeName == "second") {
                    that.$refs.linchuangxinxi.handleAeg()
                }
            },
            handleRemove(file, fileList) {
                console.log(file, fileList)
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            },
            S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            },
            guid() {
                var that = this
                return (that.S4() + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + that.S4() + that.S4());
            },
            compreObj(obj1, obj2) {
                var flag = true;

                function compre(obj1, obj2) {
                    if (!obj1) {
                        return false
                    }
                    if (Object.keys(obj1).length != Object.keys(obj2).length) {
                        flag = false;
                    } else {
                        for (var x in obj1) {
                            if (obj2.hasOwnProperty(x)) {
                                if (obj1[x] != obj2[x]) {
                                    if (typeof (obj1[x]) == "number" || typeof (obj1[x]) == "string" || typeof (obj2[x]) == "number" || typeof (obj2[x]) == "string") {
                                        flag = false;
                                    } else {
                                        compre(obj1[x], obj2[x]);
                                    }
                                }
                            } else {
                                flag = false;
                            }
                        }
                    }
                    if (flag === false) {
                        return false;
                    } else {
                        return true;
                    }
                }

                return compre(obj1, obj2)
            },
            getDiifKey(pk){
                var that = this
                this.$http.get(`/case/diff/${pk}/`).then(resp => {
                    that.$store.state.registration.form9 = resp.data.data;
                });
            },
            getData(copyid, type) {
                var that = this
                that.loading = true
                that.$store.commit('reset')
                var tmpl = JSON.parse(localStorage.getItem('tmpl'))

                let pk = this.$route.params.pk
                that.addedit = 1
                if (copyid && typeof copyid === 'number') {
                    pk = copyid
                    that.chlid = true
                    that.activeName = "first"
                    that.hidden = false
                    that.animating = false
                    that.ondisabled = false
                } else {
                    that.chlid = false
                }
                if (!pk) {
                    that.$store.state.registration.form1.uuid = that.guid()
                }
                if (pk) {
                    if (that.groups == '5' || that.groups == '7') {
                        that.activeName = 'second'
                    }
                    if (that.groups == '6') {
                        that.activeName = 'six'
                        that.$refs.zhiliaoxinxi.getData()
                    }
                    that.updateFlag = true
                    that.$http.get('/case/' + pk + '/')
                        .then(resp => {
                            Object.keys(resp.data.data).forEach(key => {
                                Object.keys(resp.data.data[key]).forEach(key2 => {
                                    that.$store.state.registration[key][key2] = resp.data.data[key][key2]
                                })
                            })
                            that.getDiifKey(pk)
                            that.status = that.$store.state.registration.form1.status
                            var timeline = that.$store.state.registration.form6.timeline
                            var flag = 0
                            if (that.groups == '6') {
                                that.$refs.zhiliaoxinxi.getData()
                            }
                            timeline.forEach(function (item) {
                                if (item.label == "治疗" || item.label == "初治") {
                                    flag = 1
                                }
                            })
                            if (flag == 1) {
                                that.$store.state.registration.form6.zhiliaofangan = {"one": "","two": "","three": "",
                                    "four": "","five": "","six": "","seven": '',"other": '',"eight": '',
                                }
                            }
                            if(typeof(that.$store.state.registration.form6.siwangyuanyin) != "object"){
                                if(that.$store.state.registration.form6.siwangyuanyin){
                                    that.$store.state.registration.form6.siwangyuanyin = [that.$store.state.registration.form6.siwangyuanyin]
                                }else{
                                    that.$store.state.registration.form6.siwangyuanyin = []
                                }
                            }
                            if(typeof(that.$store.state.registration.form4.aml_bcr_abl1_value) != "object"){
                                if(that.$store.state.registration.form4.aml_bcr_abl1_value){
                                    that.$store.state.registration.form4.aml_bcr_abl1_value = [that.$store.state.registration.form4.aml_bcr_abl1_value]
                                }else {
                                    that.$store.state.registration.form4.aml_bcr_abl1_value = []
                                }
                            }
                            if (!that.$store.state.registration.form1.uuid) {
                                that.$store.state.registration.form1.uuid = that.guid()
                            }
                            if (copyid && typeof copyid === 'number' && type != 'edit') {
                                that.$store.state.registration['form1']['pk'] = 0
                                that.$store.state.registration['form6']['newzhiliaofangan'] = ''
                                that.bingli = 1
                            } else {
                                that.bingli = resp.data.data['form1']['bingli']
                                var diff = that.compreObj(tmpl, that.$store.state.registration)
                                if (tmpl && tmpl.form1.pk == pk && !diff) {
                                    var cachet = localStorage.getItem('cachetime') || ''
                                    that.$confirm(`上次缓存时间：${cachet},发现上次暂存的内容,是否恢复？`, '提示', {
                                        confirmButtonText: '恢复',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(() => {
                                        that.bingli = tmpl['form1']['bingli']
                                        Object.keys(tmpl).forEach(key => {
                                            Object.keys(tmpl[key]).forEach(key2 => {
                                                that.$store.state.registration[key][key2] = tmpl[key][key2]
                                            })
                                        })
                                    }).catch(() => {
                                        localStorage.removeItem('tmpl')
                                    })
                                }
                            }
                            that.loading = false
                            that.$refs.fenzi.FzChange()
                            that.onStore()

                        })
                        .catch(err => {
                            console.log(err)
                            that.loading = false
                        })
                } else {
                    that.activeName = 'first'
                    that.dialogVisible = false
                    that.addedit = 1
                    that.updateFlag = false
                    var flag = 0
                    if (tmpl && tmpl.form1.pk == '') {
                        var keysList = ["xingming", "shenfenzheng", "nianling",
                            "xingbie", "huji", "zhiye", "hunyin", "dianhua", "lianxifangshi", "lianxidizhi"]
                        keysList.forEach(key => {
                            if (key == "huji") {
                                if (tmpl['form1'][key].length) {
                                    flag = 1
                                }
                            } else {
                                if (tmpl['form1'][key]) {
                                    flag = 1
                                }
                            }
                        })
                        var diff = that.compreObj(tmpl, that.$store.state.registration)
                        if (flag == 1 && !diff) {
                            var cachet = localStorage.getItem('cachetime') || ''
                            that.$confirm(`上次缓存时间：${cachet},发现上次暂存的内容,是否恢复？`, '提示', {
                                confirmButtonText: '恢复',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                Object.keys(tmpl).forEach(key => {
                                    Object.keys(tmpl[key]).forEach(key2 => {
                                        that.$store.state.registration[key][key2] = tmpl[key][key2]
                                    })
                                })
                                that.$store.state.registration.form1.uuid = that.guid()
                            }).catch(() => {
                                localStorage.removeItem('tmpl')
                            });
                        }
                    } else {
                        that.dialogVisible = true
                        that.bingli = 0
                        that.addedit = 0
                        that.$http.get("/case/autocomplete/yiyuan/").then(resp => {
                            that.$store.state.registration.form2.jiuzhenyiyuan = resp.data.data;
                            that.$store.state.registration.form8 = resp.data.form8;
                        });
                    }
                    that.loading = false
                }
            },
        },
        watch: {
            "$route": "getData"
        },
        // eslint-disable-next-line no-unused-vars
        beforeDestroy(to, form, next) {
            if (this.intervalBoxP) {
                clearInterval(this.intervalBoxP);
            }
        },
        mounted() {
            var that = this
            this.intervalBoxP = setInterval(function () {
                that.onStore()
            }, 10 * 1000)

            this.getData(0)
        }
    };
</script>

<style scoped>
    .container /deep/ .el-input__inner {
        min-width: 40px;
    }

    .container /deep/ .el-tabs__item {
        font-size: 15px;
    }

    .container /deep/ .el-alert__description {
        font-size: 14px;
    }

    .cachetime {
        float: right;
        padding: 10px;
        position: absolute;
        bottom: 0;
        right: 40px;
    }
    .calculator{
        float: right;
        cursor: pointer;
    }
</style>
